<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Create Business</h1>
            </div>
            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="business-body">
                        <div class="form-field">
                            <label>Business Name</label>
                            <input type="text" v-model="business.name" placeholder="Business Name">
                        </div>
                        <tags-input-field
                            label="keywords"
                            placeholder="Keywords"
                            input-name="keywords"
                            :data="profileKeywords"
                            @selected="handleKeywords">
                        </tags-input-field>
                        <div class="form-field">
                            <label>Sector</label>
                            <picker-selector
                                v-if="sectors.length > 0"
                                placeholder="Select Sectors"
                                :value="profileSectors"
                                input-name="sectors[]"
                                @update:modelValue="addSectors"
                                :options="sectors">
                            </picker-selector>
                        </div>
                        <div class="form-field">
                            <label>Location</label>
                            <picker-selector
                                v-if="locations.length > 0"
                                placeholder="Select Locations"
                                :value="profileLocations"
                                input-name="locations[]"
                                @update:modelValue="addLocations"
                                :options="locations">
                            </picker-selector>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">
                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                        <button class="btn-primary" type="button" @click="handleBusinessCreate">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TagsInputField from '../../TagsInputField'
    import {useStore} from "vuex"

    export default {
        name: 'BusinessCreate',
        props: {},
        components: {
            TagsInputField
        },
        data() {
            return {
                account: null,
                business: {
                    name: '',
                },
                profileSectors: null,
                profileLocations: null,
                profileKeywords: null,
            }
        },
        mounted() {
            this.setMetaTitle('View businesses | JournoLink Control')
        },
        beforeDestroy() {
        },
        methods: {
            /**
             * Emit the close event to the parent
             *
             * @return {void}
             */
            closeView() {
                this.setMetaTitle('Account Management | JournoLink Control')
                this.$root.goBack()
            },
            handleBusinessCreate() {
                axios.post(route('businesses.create', this.$route.params.accountId), {
                    name: this.business.name,
                    sectors: this.profileSectors,
                    locations: this.profileLocations,
                    keywords: this.profileKeywords,
                })
                    .then(response => {
                        this.$bus.$emit('alert.success', 'Create Success')
                        this.closeView()
                    })
                    .catch(e => {
                        this.$bus.$emit('alert.danger', 'Create Failed')
                    })
            },
            addLocations(ids) {
                console.log("Adding Locations")
                this.profileLocations = ids
            },
            addSectors(ids) {
                console.log("Adding Sectors")
                this.profileSectors = ids
            },
            /**
             * Handle an [Escape] keypress
             *
             * @return {void}
             */
            onEscapeKeypress() {
                this.closeView()
            },
            handleKeywords (keywords) {
                this.profileKeywords = keywords
            }
        },
        computed: {
            sectors () {
                const store = useStore()
                return store.state.sectors ?? []
            },
            locations () {
                const store = useStore()
                return store.state.locations ?? []
            },
        }
    }
</script>

<style lang="less">
    .business-body {
        flex: 1;
        padding: 15px;
    }

</style>
